export interface ReadFile {
  contents: string;
  filename: string;
  filetype: string;
}

export function promiseReadFile(file: File): Promise<ReadFile> {
  const filetype = file.name.substring(file.name.lastIndexOf('.') + 1, file.name.length).toLowerCase();
  const filename = file.name.substring(0, file.name.lastIndexOf('.'));

  return new Promise((res, rej) => {
    const reader = new FileReader();

    reader.onload = (data) => res({ filename, filetype, contents: (data.target as FileReader).result as string });
    reader.onerror = (err) => rej(err);

    reader.readAsDataURL(file);
  });
}

export function toUploadFile(file: ReadFile) {
  return {
    contents: file.contents,
    filename: `${file.filename}.${file.filetype}`,
  };
}
